import { Checkbox } from "@mui/material";
import Modal from "@mui/material/Modal";
import Pagination from "@mui/material/Pagination";
// import axios from "axios";
import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";
import { FiChevronDown, FiEye } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { FormatStatus } from "../../../../../utils/functions/FormatStatus";
import { formatDate } from "../../../../../utils/hooks/convertDate";
import { convertToDecimal } from "../../../../../utils/hooks/useConvertToDecimal";
import {
    useApprovePaymentRequestMutation,
    useGetPaymentSummaryQuery,
    useGeneratePaymentScheduleMutation,
    useDeclinePaymentRequestMutation,
    useGetPaymentLogQuery,
} from "../../../../api";
import PageStyle from "../../../Components/Layout/FinancePageLayout";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import { ProDropFilter, SearchFilter } from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import DashboardStyle from "../../../Styles//Dashboard.module.css";
import { URL } from "../../../../../utils/routes";

let currentHeaders = [
    {
        title: "Action",
        key: "action",
    },
    {
        title: "Category",
        key: "category",
    },
    {
        title: "Modified Date",
        key: "modifiedDate",
    },
    {
        title: "Narration",
        key: "narration",
    },
    {
        title: "Comment",
        key: "comment",
    },
    // {
    //     title: "Actions",
    //     key: null,
    // },
];

const PaymentLog = () => {
    const [search, setSearch] = useState("");
    const [page, setPage] = React.useState(1);
    const successValue = useSelector((state) => state?.global?.value);
    const [open, setOpen] = useState(false);
    const handleChange = (event, value) => {
        setPage(value);
    };
    const location = useLocation();
    const pathname = location.pathname;

    useEffect(() => {
        if (successValue === "success") {
            setOpen(false);
        }
    }, [successValue]);
    const navigate = useNavigate();
    const [approvalStatus, setApprovalStatus] = useState(0);
    const itemsPerPage = 10;


    const { data: paymentLogData } = useGetPaymentLogQuery({
        PageSize: itemsPerPage,
        ApprovalStatus: approvalStatus,
        PageNumber: page
    });
    const filteredData = paymentLogData?.responseObject?.pageItems.filter((item) => {
        const paymentType = item?.auditLogs[0]?.action.toLowerCase();
        const searchTerm = search?.toLowerCase();

        return paymentType && paymentType.includes(searchTerm);
    });
    const slicedData = filteredData?.slice(
        (page - 1) * itemsPerPage,
        page * itemsPerPage
    );

    const filteredDataByStatus = slicedData;




    const handleSearch = (e) => {
        setSearch(e.target.value);
    };


    return (
        <RouteLayout title={"Payment Requests"}>
            <PageStyle title={`Payment Requests  ${pathname?.includes(URL.PaymentRequestHOD) ? "H.O.D" : ''}`} hasBack={false} isMain={true}>
                <div className="w-full flex items-end justify-between mb-3">
                    <div className="flex items-center justify-end gap-5">
                        <SearchFilter label={'Search'}
                            text={(value) => setSearch(value)}
                            fromHeader={true}
                            onChange={handleSearch}
                        />

                    </div>
                </div>
                <div className={DashboardStyle.dashboard_table_holder}>
                    <Table>
                        <thead>
                            <tr>

                                {currentHeaders.map((header, _index) => (
                                    <th
                                        className={`!text-[#29382A] ${header.title === "Actions" && "flex justify-end !pr-6"
                                            }`}
                                        key={_index + 1}
                                    >
                                        {header.title}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>

                            {filteredDataByStatus?.map((item, index) => {

                                return (
                                    <tr key={index}>

                                        <td className="text-[#29382A] ">{item?.auditLogs[0]?.action ?? "---"}</td>
                                        <td>{item?.auditLogs[0]?.category ?? "--"}</td>
                                        <td>{formatDate(item?.auditLogs[0]?.modifiedDate) ?? "--"}</td>
                                        <td>{item?.auditLogs[0]?.narration ?? "--"} </td>
                                        <td>{item?.auditLogs[0]?.comment}</td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>

                <div className="flex justify-between">
                    <p>Showing page: {page}</p>
                    <Pagination

                        count={paymentLogData?.responseObject?.totalNumberOfPages}
                        page={page}
                        onChange={handleChange}
                    />
                </div>
                <>


                </>
            </PageStyle>
        </RouteLayout>
    );
};

export default PaymentLog;
